import ApparecchiArPage from './routes/ApparecchiArPage';
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './routes/LoginPage';
import { AccessDeniedPage } from './routes/AccessDeniedPage';
import { TenantsListPage } from './routes/TenantsListPage';
import { TenantDetailPage } from './routes/TenantDetailPage';
import { MappaAziendePage } from './routes/MappaAziendePage';
import { MappaCondivisaPage } from './routes/MappaCondivisaPage';
import { AuditLogPage } from './routes/AuditLogPage';
import { CatalogPage } from './routes/CatalogPage';
import { AnagrafePage } from './routes/AnagrafePage';
import { PricingPage } from './routes/PricingPage';
import { ConsumiPage } from './routes/ConsumiPage';
import { ConsegnePage } from './routes/ConsegnePage';
import MotoriAiPage from './routes/MotoriAiPage';
import PermessiPage from './routes/PermessiPage';
import { AppMobilePage } from './routes/AppMobilePage';
import { PlatformLeadsPage } from './routes/PlatformLeadsPage';
import { VideoDocsPage } from './routes/VideoDocsPage';
import { QuestionnairesPage } from './routes/QuestionnairesPage';
import { QuestionnaireDetailPage } from './routes/QuestionnaireDetailPage';
import { YumaSitoPage } from './routes/YumaSitoPage';
import { ProvePage } from './routes/ProvePage';
import { ReteContattiPage } from './routes/ReteContattiPage';
import { SupportTicketsPage } from './routes/SupportTicketsPage';
import PartnerPage from './routes/PartnerPage';
import { FornitureAccordiPage } from './routes/FornitureAccordiPage';
import { ListiniFornitoriPage } from './routes/ListiniFornitoriPage';
import { MfaSetupPage } from './routes/MfaSetupPage';
import { MfaVerifyPage } from './routes/MfaVerifyPage';
import { ConsoleAuthGate } from './components/ConsoleAuthGate';
import { ConsoleLayout } from './components/ConsoleLayout';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ConsoleAuthGate>
    <ConsoleLayout>{children}</ConsoleLayout>
  </ConsoleAuthGate>
);

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/mfa-setup" element={<MfaSetupPage />} />
      <Route path="/mfa-verify" element={<MfaVerifyPage />} />
      <Route path="/access-denied" element={<AccessDeniedPage />} />
      {/* La mappa delle aziende per chi ha un link condiviso: fuori dall'accesso (il codice del link è la credenziale). */}
      <Route path="/mappa/:codice" element={<MappaCondivisaPage />} />
      <Route path="/tenants" element={<Layout><TenantsListPage /></Layout>} />
      <Route path="/tenants/mappa" element={<Layout><MappaAziendePage /></Layout>} />
      <Route path="/tenants/:id" element={<Layout><TenantDetailPage /></Layout>} />
      <Route path="/audit" element={<Layout><AuditLogPage /></Layout>} />
      <Route path="/catalog" element={<Layout><CatalogPage /></Layout>} />
      <Route path="/anagrafe" element={<Layout><AnagrafePage /></Layout>} />
      <Route path="/pricing" element={<Layout><PricingPage /></Layout>} />
      <Route path="/consumi" element={<Layout><ConsumiPage /></Layout>} />
      <Route path="/consegne" element={<Layout><ConsegnePage /></Layout>} />
      <Route path="/motori-ai" element={<Layout><MotoriAiPage /></Layout>} />
      <Route path="/permessi" element={<Layout><PermessiPage /></Layout>} />
      <Route path="/app-mobile" element={<Layout><AppMobilePage /></Layout>} />
      <Route path="/apparecchi-ar" element={<Layout><ApparecchiArPage /></Layout>} />
      <Route path="/documentazione" element={<Layout><VideoDocsPage /></Layout>} />
      <Route path="/aziende" element={<Layout><PlatformLeadsPage /></Layout>} />
      <Route path="/questionari" element={<Layout><QuestionnairesPage /></Layout>} />
      <Route path="/questionari/:id" element={<Layout><QuestionnaireDetailPage /></Layout>} />
      <Route path="/yuma-sito" element={<Layout><YumaSitoPage /></Layout>} />
      <Route path="/prove" element={<Layout><ProvePage /></Layout>} />
      <Route path="/ticket" element={<Layout><SupportTicketsPage /></Layout>} />
      <Route path="/forniture" element={<Layout><FornitureAccordiPage /></Layout>} />
      <Route path="/listini-fornitori" element={<Layout><ListiniFornitoriPage /></Layout>} />
      <Route path="/rete" element={<Layout><ReteContattiPage /></Layout>} />
      <Route path="/partner" element={<Layout><PartnerPage /></Layout>} />
      <Route path="/" element={<Layout><TenantsListPage /></Layout>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
